module.exports = __webpack_public_path__ + "static/media/circle_vector.85aea6aa.png";